'use strict';

exports.__esModule = true;
var AMAN = exports.AMAN = {
  FETCH: {
    LOADING: 'FETCH_AMAN_BRANCHES_LOADING_test',
    SUCCEEDED: 'FETCH_AMAN_BRANCHES_SUCCEEDED',
    FAILED: 'FETCH_AMAN_BRANCHES_FAILED'
  },
  SUBSCIBE: {
    LOADING: 'AMAN_SUBSCRIBING_LOADING',
    SUCCEEDED: 'AMAN_SUBSCRIBING_SUCCEEDED',
    FAILED: 'AMAN_SUBSCRIBING_FAILED'
  },
  EDIT: {
    LOADING: 'EDIT_AMAN_BRANCHE_LOADING',
    SUCCEEDED: 'EDIT_AMAN_BRANCHE_SUCCEEDED',
    FAILED: 'EDIT_AMAN_BRANCHE_FAILED'
  },
  MODAL: {
    SET_BRANCH_KEY: 'MODAL_AMAN_SUBSCRIPTION_EDIT_SET_KEY',
    AMAN_SUBSCRIPTION_TOGGLE: 'MODAL_AMAN_SUBSCRIPTION_TOGGLE'
  }
};

var getAmanSuscribedBranches = exports.getAmanSuscribedBranches = function getAmanSuscribedBranches(branchesKeys /*: Array<String>*/) {
  return {
    type: AMAN.FETCH.LOADING,
    branchesKeys: branchesKeys
  };
};

var suscribeBranchesToAman = exports.suscribeBranchesToAman = function suscribeBranchesToAman(branchesKeys /*: Array<String>*/) {
  return {
    type: AMAN.SUBSCIBE.LOADING,
    branchesKeys: branchesKeys
  };
};

var editAmanBranchSubscribtion = exports.editAmanBranchSubscribtion = function editAmanBranchSubscribtion(branchDetails /*: Object*/) {
  return {
    type: AMAN.EDIT.LOADING,
    branchDetails: branchDetails
  };
};

var setCurrentBranchKey = exports.setCurrentBranchKey = function setCurrentBranchKey(branchKey /*: string*/) {
  return {
    type: AMAN.MODAL.SET_BRANCH_KEY,
    branchKey: branchKey
  };
};

var toggleAmanSubscriptionModal = exports.toggleAmanSubscriptionModal = function toggleAmanSubscriptionModal(show /*: Boolean*/, toggleAmanSubscriptionModalToEdit /*: Boolean*/) {
  return {
    type: AMAN.MODAL.AMAN_SUBSCRIPTION_TOGGLE,
    show: show,
    toggleAmanSubscriptionModalToEdit: toggleAmanSubscriptionModalToEdit
  };
};